'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _affiliatesFilter = require('./affiliates-filter.html');

var _affiliatesFilter2 = _interopRequireDefault(_affiliatesFilter);

var _affiliatesFilter3 = require('./affiliates-filter.controller');

var _affiliatesFilter4 = _interopRequireDefault(_affiliatesFilter3);

require('./affiliates-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var affiliatesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _affiliatesFilter2.default,
  controller: _affiliatesFilter4.default,
  controllerAs: 'vm'
};

exports.default = affiliatesFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/affiliates-filter/affiliates-filter.component.js
 **/